import styled from "styled-components";

/**
 * Root container — position:relative anchors arrows to card height.
 * Padding reserves space for arrow buttons on desktop; on mobile arrows overlay the card.
 */
export const CarouselInner = styled.div`
  position: relative;
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;

  @media (max-width: 500px) {
    padding: 0;
  }
`;

export const CarouselViewport = styled.div`
  /* overflow:visible lets next/prev cards peek at edges (matches old lib) */
  overflow: visible;
  width: 100%;

  @media (max-width: 500px) {
    overflow: hidden;
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
`;

/** Replaces .rec-item-wrapper */
export const CarouselSlide = styled.div`
  height: 100%;
  box-sizing: border-box;
  padding: 0 8px;
  /* No display:flex — would break float-based children (.introLabel) */
`;

const ArrowButton = styled.button`
  position: absolute;
  /* Offset down by half the avatar overhang (150px img - 90px bottom = 60px / 2 = 30px)
     so arrows align with the white card mid-point, not the full slide height */
  top: calc(50% + 30px);
  transform: translateY(-50%);
  z-index: 100;
  background: none;
  border: none;
  box-shadow: none;
  cursor: pointer;
  color: #f15922;
  font-size: 90px;
  line-height: 1;
  padding: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    color: #f15922;
    opacity: 0.3;
    cursor: default;
  }
  &:hover:not(:disabled) {
    color: #f15922;
    background: none;
    box-shadow: none;
  }

  @media (max-width: 500px) {
    font-size: 60px;
    width: 40px;
    height: 40px;
  }
`;

export const PrevButton = styled(ArrowButton)`
  left: 0;

  @media (max-width: 500px) {
    left: -5px;
  }
`;

export const NextButton = styled(ArrowButton)`
  right: 0;

  @media (max-width: 500px) {
    right: -5px;
  }
`;
